import * as React from 'react';
import { Html } from '../../helpers/html-helpers';

interface IPerformanceMessagingProps {
    performanceMessaging: string;
}

class AppMenu extends React.PureComponent<IPerformanceMessagingProps, { hideMessaging: boolean }>{
    private alertRef: React.RefObject<HTMLDivElement>;
    constructor(props) {
        super(props);
        this.state = { hideMessaging: false };
        this.alertRef = React.createRef<HTMLDivElement>();
    }
    render() {
        const useTagCloseicon = '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close" />';

        var openClass = "alert-container";
        if (!this.state.hideMessaging) {
            openClass += " alert-container-open";
            document.getElementById('app-container').classList.add('alert-container-active');
            if (this.alertRef) {
                // This will set a css custom property so that the layout can adjust to avoid the alert (on mobile), and not trap content
                setTimeout(() => {
                    const alertHeight = this.alertRef.current.offsetHeight;
                    document.body.style.setProperty('--alert-height', `${alertHeight}px`);
                }, 0);
            }
        }
        return (
            <div className={openClass} ref={this.alertRef}>
                <div className="alert-container-inner">

                    {Html.renderParagraph(this.props.performanceMessaging, "caption-paragraph")}

                    <button type="button" className="alert-close" onClick={this._alertCloseClick.bind(this)}>
                        {/*todo make dynamic*/}
                        <span className="visually-hidden">Close Alert</span>
                        <svg className="alert-close-icon" role="presentation" dangerouslySetInnerHTML={{ __html: useTagCloseicon }} ></svg>
                    </button>
                </div>

            </div>
        );
    }

    _alertCloseClick(evt) {
        evt.preventDefault();
        this.setState({ hideMessaging: true });
        document.getElementById('app-container').classList.remove('alert-container-active');
        document.body.style.setProperty('--alert-height', `0px`);
    }

}

export default AppMenu;
